(function (w, d) {
  'use strict';
  var p = w.DiyonaPrivacy;
  if (!p) return;
  var banner = d.getElementById('diy-privacy-banner'), dialog = d.getElementById('diy-privacy-dialog');
  var panel = dialog.querySelector('[role="dialog"]'), previousFocus, busy = false;
  var keys = ['analytics', 'preferences', 'marketing'];
  var footerLink = d.getElementById('diy-privacy-link-wrap'), copyright = d.querySelector('.diy-ftr-bottom__copy');
  if (footerLink && copyright) {
    footerLink.classList.add('diy-privacy-in-footer');
    copyright.appendChild(footerLink);
  }
  function input(k) { return d.getElementById('diy-privacy-' + k); }
  function message(text) { d.querySelectorAll('.diy-privacy-status').forEach(function (e) { e.textContent = text; }); }
  function update(s) {
    banner.hidden = !s.ready || s.mode !== 'opt-in' || s.hasChoice || s.gpc;
    d.getElementById('diy-privacy-region').textContent = s.gpc ? 'Global Privacy Control is enabled. Optional tracking is off.' : s.mode === 'opt-out' ? 'In your region, optional tracking is enabled unless you opt out. Your selections below show the current settings.' : 'In your region, optional tracking starts only after you give permission.';
    if (dialog.hidden) keys.forEach(function (k) { input(k).checked = k === 'marketing' ? s.advertisingAllowed : s[k]; });
    keys.forEach(function (k) { input(k).disabled = busy || !s.ready || s.gpc; });
    d.querySelectorAll('[data-privacy-action="accept"]').forEach(function (e) { e.disabled = busy || !s.ready || s.gpc; });
  }
  function open() {
    previousFocus = d.activeElement;
    var s = p.get();
    keys.forEach(function (k) { input(k).checked = k === 'marketing' ? s.advertisingAllowed : s[k]; });
    dialog.hidden = false; update(s); panel.focus();
  }
  function close() { dialog.hidden = true; if (previousFocus && previousFocus.focus) previousFocus.focus(); }
  function save(action) {
    if (busy) return;
    var v = {};
    keys.forEach(function (k) { v[k] = action === 'accept' || (action === 'save' && input(k).checked); });
    v.sale_of_data = v.marketing;
    var before = p.get();
    busy = true; message('Saving your choices…');
    d.querySelectorAll('.diy-privacy-actions button').forEach(function (e) { e.disabled = true; });
    p.set(v, function (error) {
      busy = false;
      d.querySelectorAll('.diy-privacy-actions button').forEach(function (e) { e.disabled = false; });
      update(p.get());
      if (error) { open(); message(error.message); return; }
      message('Your privacy choices are saved.'); close();
      // Restart the page after a changed choice to discard vendor memory and stale queued callbacks.
      if (before.analytics || before.advertisingAllowed || before.preferences) w.location.reload();
    });
  }
  d.addEventListener('click', function (e) {
    var el = e.target.closest('[data-privacy-action]'); if (!el) return;
    e.preventDefault(); e.stopPropagation(); var action = el.getAttribute('data-privacy-action');
    if (action === 'open') open(); else if (action === 'close') close(); else save(action);
  }, true);
  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !busy) { close(); return; }
    if (e.key !== 'Tab') return;
    var list = Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled)'));
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && (d.activeElement === first || d.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  p.subscribe(update);
})(window, document);
